import Axios, { AxiosRequestConfig } from 'axios';

import { getAppStore } from '~src/app/AppStore';
import { setRootAdminUiState } from '~src/app/rootAdminUi/RootAdminUiStateActions';
import { Tableau } from '~src/common/utilities/TableauLog';
import WebHttpClient from '~src/httpClient/WebHttpClient';
import { L10n } from '~src/ts/L10n/L10n';

// replacement for config.ts $httpProvider.interceptor request handler
export function configGetUrl(config: AxiosRequestConfig) {
 const apiRequestRegex = new RegExp('^' + WebHttpClient.API_PREFIX);
 const isGet = config.method === 'GET';
 const isInline = /^inline_/.test(config.url);
 const isApi = apiRequestRegex.test(config.url);
 if (isGet && !isInline && !isApi) {
   const separator = (config.url.indexOf('?') >= 0) ? '&' : '?';
   config.url = StaticAssetsUrlPrefix + config.url + separator + BuildId;
 }
 return config;
}
Axios.interceptors.request.use(configGetUrl);

// replacement for config.ts $httpProvider.interceptor response handler
function goToFatalErrorState(message: string) {
  Tableau.Logger().error(message);

  getAppStore().dispatch(setRootAdminUiState('fatal'));
}

export function configHandleError(rejection: any) {
  Tableau.Logger().error('http error ' + rejection.response.status + ' for request ' + rejection.config.url);
    if ((rejection.response.status === 404) && (rejection.config.url.indexOf('messages.') >= 0)) {
      // if failed to get strings for a language other than English, it will fall back to English in AuthenticationService but if the language is English...
      if (L10n.language === 'en') {
        goToFatalErrorState('Failed to load strings for UI.');
      }
    }
return Promise.reject(rejection);
}

Axios.interceptors.response.use(undefined, configHandleError);